/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Icon, List, SiteSectionGroup, SiteSectionGroupMovePosition, SiteSectionGroupTitle } from "./data-contracts";

/**
 * No description
 * @tags site-section-groups
 * @name ListSiteSectionGroups
 * @summary List all site section groups
 * @request GET:/orgs/{organizationId}/sites/{siteId}/section-groups
 * @secure
 */

// @ts-ignore
export const listSiteSectionGroups: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSectionGroup[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups",
  method: "get",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name AddSectionGroupToSite
 * @summary Add a section group to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups
 * @secure
 */

// @ts-ignore
export const addSectionGroupToSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section group */
    title: SiteSectionGroupTitle;
    icon?: Icon | null;
    /** IDs of the sections to be added to the section group */
    sections?: string[];
    /** ID of the parent section group to nest this group under. If not provided, the section group will be added at the root of the site. */
    parent?: string;
  };
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups",
  method: "post",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name UpdateSiteSectionGroupById
 * @summary Update a site section group
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
 * @secure
 */

// @ts-ignore
export const updateSiteSectionGroupById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section group */
    title?: SiteSectionGroupTitle;
    icon?: Icon | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
  method: "patch",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name DeleteSiteSectionGroupById
 * @summary Delete a site section group
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSectionGroupById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
  method: "delete",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name AddSectionToGroup
 * @summary Add a section to a section group
 * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/sections
 * @secure
 */

// @ts-ignore
export const addSectionToGroup: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** ID of the section to add to the section group */
    sectionId: string;
  };
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/sections",
  method: "post",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name RemoveSectionFromGroup
 * @summary Remove a section from a section group
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/sections/{siteSectionId}
 * @secure
 */

// @ts-ignore
export const removeSectionFromGroup: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/sections/{siteSectionId}",
  method: "delete",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name MoveSiteSectionGroup
 * @summary Move a site section group to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSectionGroup: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The position where to move the site section group. When not provided the site section group is moved at the end of the site. */
    position?: SiteSectionGroupMovePosition;
  };
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move",
  method: "post",
  streaming: false,
  tags: ["site-section-groups"],
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
